export const ADMIN_PROPERTY_STATUSES = [
  "Incomplete",
  "Available",
  "Pending",
  "Hold",
  "Sold",
  "Canceled",
  "Testing",
];

export const ADMIN_PROPERTY_STATUS_OPTIONS = ADMIN_PROPERTY_STATUSES.map(
  (status) => ({
    value: status,
    label: status,
  })
);

export const PUBLIC_PROPERTY_FILTER_STATUSES = [
  "Available",
  "Pending",
  "Sold",
  "Canceled",
  "Testing",
];

export const normalizePropertyStatus = (status) => {
  if (status === "Cancelled") return "Canceled";
  return status || "";
};

export const getPropertyStatusLabel = (status) =>
  normalizePropertyStatus(status) || "Unknown";

export const getPropertyStatusBadgeClassName = (status) => {
  switch (normalizePropertyStatus(status)) {
    case "Incomplete":
      return "bg-purple-100 text-purple-800";
    case "Available":
      return "bg-green-100 text-green-800";
    case "Pending":
      return "bg-orange-100 text-orange-800";
    case "Hold":
      return "bg-amber-100 text-amber-900";
    case "Sold":
      return "bg-rose-100 text-rose-900";
    case "Canceled":
      return "bg-gray-100 text-gray-800";
    case "Testing":
      return "bg-sky-100 text-sky-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getPropertyStatusIndicatorClasses = (status) => {
  switch (normalizePropertyStatus(status)) {
    case "Incomplete":
      return { circle: "bg-purple-500", text: "text-purple-500" };
    case "Available":
      return { circle: "bg-green-500", text: "text-green-500" };
    case "Pending":
      return { circle: "bg-yellow-500", text: "text-yellow-500" };
    case "Hold":
      return { circle: "bg-amber-500", text: "text-amber-600" };
    case "Canceled":
    case "Sold":
      return { circle: "bg-red-500", text: "text-red-500" };
    case "Testing":
      return { circle: "bg-blue-500", text: "text-blue-500" };
    default:
      return { circle: "bg-gray-400", text: "text-gray-400" };
  }
};

export const isActivePropertyStatus = (status) => {
  const normalizedStatus = normalizePropertyStatus(status);
  return normalizedStatus === "Available" || normalizedStatus === "Pending";
};

export const isDirectDeletePropertyStatus = (status) => {
  const normalizedStatus = normalizePropertyStatus(status);
  return (
    normalizedStatus === "Sold" ||
    normalizedStatus === "Canceled" ||
    normalizedStatus === "Hold" ||
    normalizedStatus === "Testing"
  );
};

export const analyzePropertyStatuses = (properties = []) => {
  const counts = {
    incomplete: 0,
    available: 0,
    pending: 0,
    hold: 0,
    sold: 0,
    canceled: 0,
    testing: 0,
    other: 0,
  };

  properties.forEach((property) => {
    switch (normalizePropertyStatus(property?.status)) {
      case "Incomplete":
        counts.incomplete += 1;
        break;
      case "Available":
        counts.available += 1;
        break;
      case "Pending":
        counts.pending += 1;
        break;
      case "Hold":
        counts.hold += 1;
        break;
      case "Sold":
        counts.sold += 1;
        break;
      case "Canceled":
        counts.canceled += 1;
        break;
      case "Testing":
        counts.testing += 1;
        break;
      default:
        counts.other += 1;
        break;
    }
  });

  return counts;
};
